import { render, staticRenderFns } from "./AccessManagement.vue?vue&type=template&id=635f4386&scoped=true"
import script from "./AccessManagement.vue?vue&type=script&lang=js"
export * from "./AccessManagement.vue?vue&type=script&lang=js"
import style0 from "./AccessManagement.vue?vue&type=style&index=0&id=635f4386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f4386",
  null
  
)

export default component.exports